/* eslint-disable import/prefer-default-export */
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from './TextInput';
import { useValidationMessagingArgs, ValidationStates } from './ValidationMessages';

interface LastNameProps {
    initialValue?: string;
}

const verification: useValidationMessagingArgs = {
    applicableStates: [ValidationStates.MissingRequired],
};

export const LastName: React.FC<LastNameProps> = ({ initialValue }) => {
    const { t } = useTranslation(['common']);

    return (
        <TextInput
            formFieldId="LastName"
            isRequired
            inputValidation={verification}
            label={t('common:lastName')}
            name="LastName"
            initialValue={initialValue}
        />
    );
};
